@use "../../../../../styles/Constants.scss" as Constants;
@use "../../../../../styles/Colors.scss" as Colors;

.credential-row-container {
	display: flex;
	align-items: center;
}

.user-group {

	&__selected {
		font-weight: bold;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}

.ellipsis {
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
